module.exports = {
	WAITING: 0,
	RUNNING: 1,
	AD_REQUESTING: 2,
	DONE: 3,
};
